import React from 'react';
import { Helmet } from 'react-helmet';
import { useLang } from '../../context/LanguageContext';

const defaultMeta = {
  pl: {
    title: 'Modernware – Agencja Software z AI | Aplikacje webowe i mobilne',
    description: 'Tworzymy nowoczesne aplikacje webowe i mobilne wzmocnione przez AI. Szybciej, mądrzej, z lepszym doświadczeniem użytkownika. Katowice, Polska.',
    keywords: 'agencja software, aplikacje webowe, aplikacje mobilne, AI, React, Node.js, Katowice, tworzenie aplikacji',
  },
  en: {
    title: 'Modernware – AI-Powered Software Agency | Web & Mobile Apps',
    description: 'We build modern web and mobile applications powered by AI. Faster, smarter, with a better user experience. Based in Katowice, Poland.',
    keywords: 'software agency, web applications, mobile apps, AI, React, Node.js, Katowice, app development',
  },
};

const SEO = ({ title, description, image, path = '' }) => {
  const { lang } = useLang();
  const meta = defaultMeta[lang];

  const resolvedTitle = title || meta.title;
  const resolvedDesc = description || meta.description;
  const resolvedImage = image || 'https://modernware.io/images/modernware.jpg';
  const canonical = `https://modernware.io${path}`;
  const ogLocale = lang === 'pl' ? 'pl_PL' : 'en_US';

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Modernware',
    description: resolvedDesc,
    url: 'https://modernware.io',
    email: 'hello@modernware.io',
    telephone: '+48798094110',
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Kościuszki 55',
      addressLocality: 'Katowice',
      postalCode: '40-174',
      addressCountry: 'PL',
    },
    sameAs: [],
  };

  return (
    <Helmet>
      <html lang={lang} />
      <title>{resolvedTitle}</title>
      <meta name="description" content={resolvedDesc} />
      <meta name="keywords" content={meta.keywords} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={canonical} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={resolvedTitle} />
      <meta property="og:description" content={resolvedDesc} />
      <meta property="og:image" content={resolvedImage} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content={ogLocale} />
      <meta property="og:site_name" content="Modernware" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={resolvedTitle} />
      <meta name="twitter:description" content={resolvedDesc} />
      <meta name="twitter:image" content={resolvedImage} />

      {/* JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(jsonLd)}
      </script>
    </Helmet>
  );
};

export default SEO;
